export default {
	prepareSequenceImages: Array(31)
		.fill('')
		.map((v, i) =>
		require(`../../../Box_sequences/00_TV_clean_box/TV_clean_box${i < 10 ? `0${i}` : i}.jpg`)
		),
	designSliderImage: require('../../../product drawing/polar bear.png'),
	designImageList: [
		{
			number: 1,
			side: 'TOP',
			image: require('../../../parts/polarbear/Bear01.png'),
		},
		{
			number: 2,
			side: 'MIDDLE',
			image: require('../../../parts/polarbear/Bear02.png'),
		},
		{
			number: 3,
			text: '-a',
			side: 'BOTTOM',
			sideNumber: '1',
			image: require('../../../parts/polarbear/Bear03.png'),
		},
		{
			number: 3,
			text: '-b',
			side: 'BOTTOM',
			sideNumber: '2',
			image: require('../../../parts/polarbear/Bear04.png'),
		},
		{
			number: 4,
			side: 'FACE',
			image: require('../../../parts/polarbear/Bear05.png'),
		},
	],
	cutOutPartsImage: require('../../../parts/polarbear/Bear06.png'),
	cutOutPartsFoldImage: require('../../../parts/polarbear/Bear07.png'),
	assembleSequenceImages: Array(46)
		.fill('')
		.map((v, i) =>
			require(`../../../sequences/09_polarBear_sequence/Bear${
				i < 10 ? `0${i}` : i
			}.jpg`)
		),
	completeImage: require('../../../complete/Endangered-Animals-01.jpg'),
	completeImagePc: require('../../../complete/Endangered-Animals-01.jpg'),
};
